//aws amplfy
import Amplify, { Auth } from 'aws-amplify'
import { ConnectedRouter } from 'connected-react-router'
// import { Store } from 'redux'
import { History } from 'history'
import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import awsconfig from './aws-exports'
// import { ApplicationState } from './store'
// import LayoutContainer from './containers/LayoutContainer'
// import * as themes from './styles/theme'
import CustomAuth from './components/authentication/CustomAuth'
import firebase from './firebase'
// import { ThemeProvider } from 'emotion-theming'
import Routes from './routes.js'
import { getDecryptIdAPI, getNotificationDetails, saveUserNotification, updateNotificationStatus } from './source/ApiCall'
import axios from 'axios'
import { getGateWayToken, getProperEmailId, getUserDetails } from './actions/homeActions'
import Loader from './source/CommonLoader'

Amplify.configure(awsconfig)

// Create an intersection type of the component props and our Redux props.
const Main = ({ store, history }) => {
  // let route_history = useHistory();
  // let location = useLocation();
  const isLoggedstorage = localStorage.getItem('isLogged')
  const [isLogged, setIsLogged] = useState(isLoggedstorage === 'true')
  const [isLoading, setIsLoading] = useState(true)
  const [loader, setLoader] = useState(false)
  const [initializingAuth, setInitializingAuth] = useState(true)
   const hasStateToken =
      window.location.hash &&
      window.location.hash.includes('state=')
  let queryParams = new URLSearchParams(window.location.search);
  const isReimbursementDeepLink = queryParams.has('reimbursement') && queryParams.get('reimbursement') === 'true'

  useEffect(() => {
    const channel = new BroadcastChannel('signout_channel')

    channel.onmessage = event => {
      if (isReimbursementDeepLink) {
        return
      }

      if (event.data === 'signout') {
        localStorage.clear()
        sessionStorage.clear()

        setIsLogged(false)

        window.location.reload()
      }
    }

    return () => channel.close()
  }, [isReimbursementDeepLink])

  useEffect(() => {
    const authChannel = new BroadcastChannel('auth_sync_channel')

    authChannel.onmessage = event => {
      if (isReimbursementDeepLink) {
        return
      }

      const data = event.data

      if (data?.type === 'NEW_LOGIN') {
        // If our current storage matches what was broadcasted, stay perfectly still.
        if (sessionStorage.getItem('urls') === data.token) {
          return
        }

        sessionStorage.setItem('urls', data.token)
        setIsLogged(true) 
        setIsLoading(false)

        // Gracefully delay reload to clear out active UI execution blocks
        setTimeout(() => {
          window.location.reload()
        }, 200);
      }
    }

    return () => authChannel.close()
  }, [isReimbursementDeepLink])

    const urlpath = (path) => {
      switch (path.toLowerCase()) {
        case 'payment':
        case '/payment':
          return '/Transaction'
        default:
          return '/'
      }
    }
  
  useEffect(() => {
   
    sessionStorage.setItem('chatwindow', 'false');

    // Register the firebase messaging service worker and initialize messaging
    if (firebase.messaging && firebase.messaging.isSupported && firebase.messaging.isSupported()) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then(registration => {
          console.log('Service Worker registered for FCM:', registration)

          const msg = firebase.messaging()

          // Tell firebase messaging to use this service worker
          if (msg.useServiceWorker) {
            try {
              msg.useServiceWorker(registration)
            } catch (e) {
              console.warn('useServiceWorker failed', e)
            }
          }

          // Request notification permission and get token
          return Notification.requestPermission().then(permission => {
            console.log('Notification permission:', permission)
            if (permission === 'granted') {
              const vapidKey = "BEhiOfeIC5zM-rJkG2TM21jJT4NDFzeynReNKJqKEbduNfdnk98NoROpCJnuBXotH-7L_QUPE7cmiYVJr9iLZM8"
              const getTokenOptions = vapidKey ? { vapidKey } : undefined
              return msg.getToken(getTokenOptions).then(token => {
                console.log('Firebase token obtained:', token ? 'success' : 'failed')
                return { msg, token, registration }
              })
            }
            throw new Error('Notification permission not granted')
          })
        })
        .then(({ msg, token, registration }) => {
          if (token) {
            localStorage.setItem('TOKEN_TYPE', 'web')
            localStorage.setItem('firebaseToken', token)
            console.log('Firebase token stored:', token)
            if (!isReimbursementDeepLink) {
              saveUserNotificationDetails()
            } else {
              console.log('Skipping database token sync for public anonymous view.');
            }
          }

          // Listen for foreground messages
          if (msg && msg.onMessage) {
            console.log('Setting up foreground message listener...')
            msg.onMessage(payload => {
              console.log('=== FOREGROUND MESSAGE RECEIVED ===')
              console.log('Full payload:', JSON.stringify(payload, null, 2))
              
              // Only show notification if the app is actually in focus
              if (document.hidden && payload.notification) {
                // App is backgrounded, let service worker handle it
                console.log('App is backgrounded, skipping foreground notification')
                return
              }
              
              else if (payload.notification && !document.hidden) {
                const notificationTitle = payload.notification.title || 'Notification'
                const notificationOptions = {
                  body: payload.notification.body || payload.data?.body || '',
                  icon: payload.notification.icon || '/logo.png',
                  badge: '/logo.png',
                  data: payload.data || {},
                  tag: 'foreground-notification',
                  requireInteraction: true,
                  actions: [
                    {
                      action: 'open',
                      title: 'Open'
                    }
                  ]
                }
                
                if (registration && registration.showNotification) {
                  console.log('Showing foreground notification via registration...')
                  registration.showNotification(notificationTitle, notificationOptions)
                    .then(() => {
                      console.log('Foreground notification shown successfully')
                      updateBadgeCount()
                    })
                    .catch(err => console.error('Foreground notification error:', err))
                }
              }
            })
          }

          // Setup service worker message listener ONLY ONCE (moved here)
          if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            console.log('Setting up service worker message listener')
            navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage)
          }

          return registration
        })
        .catch(err => {
          console.warn('FCM service worker / token error:', err)
        })
    } else {
      console.log('Firebase messaging is not supported in this browser.')
    }

    let url = window.location.href
    if (url.includes('#state=')) {
      setLoader(true)

      const splitUrl = url.split('state=')[1]

      if (splitUrl) {
        const decodedToken = decodeURIComponent(splitUrl);

        // CRITICAL FIX: If this is a completely fresh user token, clean the slate!
        if (sessionStorage.getItem('urls') !== decodedToken) {
          // Isolate current frame identification markers instantly
          sessionStorage.setItem('urls', decodedToken);
          sessionStorage.setItem('launch', 'true');
          sessionStorage.removeItem('USER_ACTIVE_SESSION');

          localStorage.setItem('isLogged', 'true');
          setIsLogged(true);

          // ONLY broadcast synchronization alerts if this is a deliberate manual update event,
          // never during concurrent initial component boot cycles.
          if (localStorage.getItem('bearerToken')) {
            const authChannel = new BroadcastChannel('auth_sync_channel')
            authChannel.postMessage({
              type: 'NEW_LOGIN',
              token: decodedToken,
              fullUrl: window.location.href
            });
            authChannel.close();
          }
          // Save initial configurations from query string parameters
          
          if (queryParams.has('admin')) localStorage.setItem('isAdmin', 'true');
          if (queryParams.has('reimbursement') && queryParams.get('reimbursement') === 'true') {
            sessionStorage.setItem('REDIRECT_REIMBURSEMENT_ONLY', 'true');
          }
          if (queryParams.has('SC') && queryParams.get('SC') === 'true') {
            localStorage.setItem('isServiceCloud', 'true');
          }
          if (queryParams.has('email')) {
            localStorage.setItem('initiatedUser', queryParams.get('email'));
          }

          getGateWayToken(decodedToken);
          
          return;
        } 
        
        // If it's an accidental reload of the same token, gracefully halt loader
        else if (localStorage.getItem('isLogged') === 'true') {
          setLoader(false);
          return;
        }
      }
    }

     if (isReimbursementDeepLink) {
      setIsLogged(true);
      setIsLoading(false);
      setInitializingAuth(false)
    }else if (sessionStorage.getItem('USER_ACTIVE_SESSION') === 'true') {
      setIsLogged(true)
      setIsLoading(false)
      localStorage.setItem('isLogged', 'true')
      setInitializingAuth(false)
    } else {
      Auth.currentSession()
        .then((session) => {
          parseJwt(session.idToken.jwtToken)
          setIsLogged(true)
          setIsLoading(false)
          localStorage.setItem('isLogged', 'true')
          saveUserNotificationDetails()
          setInitializingAuth(false)
        })
        .catch((error) => {
          // If no valid tokens exist and no active session matches, hold on unauthenticated view
          if (!window.location.hash.includes('state=')) {
            setIsLogged(false);
            localStorage.setItem('isLogged', 'false');
          }
          setIsLoading(false)
          setInitializingAuth(false)
        })
    }

    window.addEventListener('storage', handleStorageChange)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      if (navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage)
      }
    }
  }, [])

  // Service worker message handler
  const handleServiceWorkerMessage = (event) => {
    console.log('Message from service worker:', event.data);
    if (event.data && event.data.type === 'NOTIFICATION_CLICK') {
      const urlPath = event.data.urlPath;
      console.log('Original urlPath from notification:', urlPath);
      
      // Use your existing urlpath() function to map the URL
      const mappedPath = urlPath;
   
        if(event.data.notificationId) {
           let obj = { notificationId: event.data.notificationId || null }
          updateNotificationStatus(obj).then(res => {
              history.push(mappedPath);
          })
        } else {
            history.push(mappedPath);
        }

     
    }
  }

  // const checkPendingNotificationUrl = () => {
  //   const request = indexedDB.open('NotificationDB', 1);
    
  //   request.onupgradeneeded = function(event) {
  //     const db = event.target.result;
  //     if (!db.objectStoreNames.contains('notifications')) {
  //       console.log('Creating notifications object store...');
  //       db.createObjectStore('notifications', { keyPath: 'id' });
  //     }
  //   };
    
  //   request.onsuccess = function() {
  //     const db = request.result;
  //     const transaction = db.transaction(['notifications'], 'readonly');
  //     const store = transaction.objectStore('notifications');
  //     const getRequest = store.get('pending');
      
  //     getRequest.onsuccess = function() {
  //       const data = getRequest.result;
  //       if (data && data.urlPath) {
  //         console.log('Found pending notification URL:', data.urlPath);
          
  //         // Navigate to the URL
  //         setTimeout(() => {
  //           console.log('Navigating to pending URL:', data.urlPath);
  //           window.location.href = '/' + data.urlPath.replace(/^\/+/, '');
  //           updateBadgeCount()
  //         }, 500);
          
  //         // Delete the stored URL
  //         const deleteTransaction = db.transaction(['notifications'], 'readwrite');
  //         const deleteStore = deleteTransaction.objectStore('notifications');
  //         const deleteRequest = deleteStore.delete('pending');
  //         deleteRequest.onsuccess = () => {
  //           console.log('Cleared pending notification URL');
  //         };
  //       }
  //     };
  //   };
    
  //   request.onerror = function() {
  //     console.error('IndexedDB error:', request.error);
  //   };
  // }

  const updateBadgeCount = async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      if (registrations.length > 0 && registrations[0].scope) {
       
        
          getNotificationDetails().then(res => {
            if (res.data && res.data.response) {
              localStorage.setItem('notificationCount', res.data.response.count.toString())
               if (navigator.setAppBadge) {
                  navigator.setAppBadge(res.data.response.count)
                }
                console.log('Badge count updated:', res.data.response.count)
            }
          })
       
      }
    } catch (err) {
      console.error('Error updating badge:', err)
    }
  }

  const handleStorageChange = (event) => {
    // reimbursement tabs should stay isolated
    if (isReimbursementDeepLink) {
      return
    }
    if (event.key === 'userMail' && sessionStorage.getItem('launch')) {
      window.location.reload()
    }
  }

  const getGateWayToken = (params) => {
    let request = {
      username: process.env.REACT_APP_GETWAY_TOKEN_USERNAME,
      password: process.env.REACT_APP_GETWAY_TOKEN_PASS
    }
    axios.post(process.env.REACT_APP_BASE_URL + 'v1/login', request).then(data => {
      let bearer = data['headers'].authorization
      var array = bearer.split('Bearer ')
      localStorage.setItem('bearerToken', array[1])
      let decodeurl = decodeURIComponent(params)
      getDecodeData(decodeurl)
    })
  }
  const getDecodeData = async (data) => {
    await getDecryptIdAPI(data)
      .then((resp) => {
        getuserData(resp)
      })
      .catch(err => {
        console.log('went wrong:', err)
      })
  }

  const getuserData = async (data) => {
    try {
      let email = await getProperEmailId(data)
      let userData = await getUserDetails(email)
      if (userData) {
        setLoader(false)
        let find = userData.data.memberIdCardList[userData.data.memberIdCardList.length - 1]
        localStorage.setItem('SOURCE', find.source)
        localStorage.setItem('sourceid', userData.data.memberIdCardList[0].memberId)
        localStorage.setItem('CLIENT_ID', find.clientId)
        localStorage.setItem('planId', userData.data.memberIdCardList[0].planId)
        localStorage.setItem('userMail', email)
        if (userData.data.memberIdCardList[0].guardian) {
          localStorage.setItem('isGuardian', 'true')
          localStorage.setItem(
            'guardianName',
            userData.data.memberIdCardList[0].guardian.firstName + ' ' + userData.data.memberIdCardList[0].guardian.lastName
          )
        }
        localStorage.setItem(
          'subscriberName',
          `${userData.data.memberIdCardList[0].prefix || ""} ${userData.data.memberIdCardList[0].firstName || ""} ${userData.data.memberIdCardList[0].middleName || ""} ${userData.data.memberIdCardList[0].lastName || ""} ${userData.data.memberIdCardList[0].suffix || ""}`
        )
        let contact = userData.data.memberIdCardList[userData.data.memberIdCardList.length - 1].planInfo.find(
          (obj) => obj.idcardField == 'contact number'
        )
        contact ? localStorage.setItem('CONTACT_NUMBER', contact.fieldValue) : localStorage.setItem('CONTACT_NUMBER', 'NA')
        // window.history.replaceState({}, document.title, '/')
        if (window.location.href.toLowerCase().includes('reimbursement') || isReimbursementDeepLink) {
          sessionStorage.setItem('REDIRECT_REIMBURSEMENT_ONLY', 'true');
          sessionStorage.setItem('sourceid', userData.data.memberIdCardList[0].memberId)
          sessionStorage.setItem('userMail', email)
          sessionStorage.setItem(
          'subscriberName',
          `${userData.data.memberIdCardList[0].prefix || ""} ${userData.data.memberIdCardList[0].firstName || ""} ${userData.data.memberIdCardList[0].middleName || ""} ${userData.data.memberIdCardList[0].lastName || ""} ${userData.data.memberIdCardList[0].suffix || ""}`
        )
        }else{
          sessionStorage.setItem('USER_ACTIVE_SESSION', 'true')
        }
        setIsLogged(true)
        setInitializingAuth(false)
      }
    } catch (err) {
      window.location.href = '/login'
      setLoader(false)
      setInitializingAuth(false)
    }
  }
  const saveUserNotificationDetails = () => {
    let email = localStorage.getItem('userMail')
    let phone = localStorage.getItem('phone')
    let username = localStorage.getItem('subscriberName')
    let firebase = localStorage.getItem('firebaseToken')
    let type = localStorage.getItem('TOKEN_TYPE')
    let client_id = localStorage.getItem('CLIENT_ID')
    let obj = {
      email: email,
      phone: phone,
      username: username,
      token: firebase,
      type: type,
      clientId: client_id
    }
    console.log('Main tsx saveUserObject=====', obj)
    saveUserNotification(obj).then(res => {
      console.log('seva user++++++++')
    })
  }

  const parseJwt = (token) => {
    // console.log('inside parse')
    // console.log('token:' + token)
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )
    var token = JSON.parse(jsonPayload)
    // console.table(token)
    localStorage.setItem('userMail', token.email)
    // localStorage.setItem('subscriberName', token.name)
    localStorage.setItem('phone', token.phone_number)
    localStorage.setItem('cognitoUsername', token['cognito:username'])
    localStorage.setItem('isLogged', 'true')
    if (localStorage.getItem('popupShow') && localStorage.getItem('popupShow') === 'false') {
      localStorage.setItem('popupShow', 'false')
    } else {
      localStorage.setItem('popupShow', 'true')
    }

    if (localStorage.getItem('healthQuestionModal') && localStorage.getItem('healthQuestionModal') === 'false') {
      localStorage.setItem('healthQuestionModal', 'false')
    } else {
      localStorage.setItem('healthQuestionModal', 'true')
    }

    return token.email
  }

  const isProcessingNewToken = window.location.hash && window.location.hash.includes('state=');

  if (initializingAuth && !hasStateToken) {
    return <Loader />
  }
  if (loader) {
    return <Loader />
  } else {
    if (!isLogged || isReimbursementDeepLink || isProcessingNewToken) {
      return (
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <CustomAuth />
          </ConnectedRouter>
        </Provider>
      )
    } else {
      return (
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Routes />
          </ConnectedRouter>
        </Provider>
      )
    }
  }
}

// Normally you wouldn't need any generics here (since types infer from the passed functions).
// But since we pass some props from the `index.js` file, we have to include them.
// For an example of a `connect` function without generics, see `./containers/LayoutContainer`.
export default Main
// export default withAuthenticator(Main, true);
